/**
 * Pill-shaped multi-line option button used by every "pick one of these"
 * step (role, teaching area, class size, main interest, main goal,
 * pilot). Visual parity with the mobile `optionBtn` helper.
 */

import PropTypes from "prop-types";
import ButtonBase from "@mui/material/ButtonBase";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { useTheme } from "@mui/material/styles";

export default function DemoOptionButton({ label, sub, selected, onPress }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  return (
    <ButtonBase
      onClick={onPress}
      sx={{
        width: "100%",
        textAlign: "left",
        borderRadius: 3,
        border: "1px solid",
        borderColor: selected ? "primary.main" : "divider",
        bgcolor: selected
          ? `${theme.palette.primary.main}18`
          : isDark
            ? "background.paper"
            : "background.default",
        px: 2,
        py: 1.5,
        mb: 1.25,
        transition: "all 150ms ease",
        "&:hover": {
          borderColor: "primary.main",
          bgcolor: selected
            ? `${theme.palette.primary.main}22`
            : `${theme.palette.primary.main}0C`,
        },
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 15,
            color: "text.primary",
          }}
        >
          {label}
        </Typography>
        {sub && (
          <Typography
            sx={{
              fontSize: 12,
              color: "text.secondary",
              mt: 0.25,
              lineHeight: 1.5,
            }}
          >
            {sub}
          </Typography>
        )}
      </Box>
      {selected && (
        <CheckCircleRoundedIcon
          sx={{ color: "primary.main", fontSize: 22, ml: 1 }}
        />
      )}
    </ButtonBase>
  );
}

DemoOptionButton.propTypes = {
  label: PropTypes.string.isRequired,
  sub: PropTypes.string,
  selected: PropTypes.bool,
  onPress: PropTypes.func.isRequired,
};

DemoOptionButton.defaultProps = {
  sub: null,
  selected: false,
};
